import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import * as Yup from "yup";
import AadharOTPAuthentication from "./AadharOTPAuthentication";
// import Colors from "../../../utility/Colors";

const AadharAuthentication = forwardRef(
  ({ message, onVerify, onResend }, ref) => {
    const authRef = useRef(null);
    const [mobileNumber, setMobileNumber] = useState("");
    useImperativeHandle(ref, () => ({
      getDetails,
    }));

    const getDetails = () => {
      let val = authRef.current.getDetails();
      if (val) {
        let v = validateValue("^(0)?[6-9]{1}[0-9]{9,12}$", mobileNumber);
        if (v) {
          return {
            otp: val,
            mobileNumber: mobileNumber,
          };
        }
      }
      return false;
    };
    const [isValid, setIsValid] = useState(false);
    const handleMobileNumberChange = (e) => {
      // if (validation !== "") {
      if (e.target.value) {
        if (new RegExp("^[0-9]{0,10}$").test(e.target.value)) {
          setMobileNumber(e.target.value);
        }
      } else setMobileNumber("");
      // }

      return false;
      if (e.target.value) {
        let v = validateValue(/^[0-9]{0,10}$/, parseInt(e.target.value));
        console.log(v, "v");

        if (!v) {
          setMobileNumber(e.target.value);
        }
      } else {
        setMobileNumber("");
      }
    };

    useEffect(() => {
      let v1 = validateValue("^(0)?[6-9]{1}[0-9]{9,12}$", mobileNumber);
      if (v1) {
        setIsValid(true);
      } else setIsValid(false);
    }, [mobileNumber]);
    return (
      <Box>
        <AadharOTPAuthentication
          onVerify={onVerify}
          onResend={onResend}
          message={message}
          ref={authRef}
        />
        <Box>
          {/* <Typography>
          Mobile Number <span style={{ color: "#f00" }}>*</span>
        </Typography> */}

          <Grid container spacing={4} sx={{ p: 1 }}>
            <Grid item size={{ xs: 12, md: 6 }}>
              <InputLabel sx={{ mb: 2 }}>
                Enter Mobile Number
                <span style={{ color: "#f00" }}>*</span>
              </InputLabel>
              <TextField
                variant="outlined"
                size="small"
                // label={field.label}
                required={true}
                value={mobileNumber}
                type={"text"}
                // onChange={handleMobileNumberChange}
                fullWidth
                inputProps={{
                  onInput: (e) => {
                    handleMobileNumberChange(e);
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        backgroundColor: "#E9ECF3",
                        p: 1,
                        borderRadius: "5px",
                      }}
                    >
                      +91
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <CheckCircleIcon
                          color={isValid ? "success" : "disabled"}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={!isValid}
                helperText={isValid ? "" : "Please enter valid mobile number"}
              />
            </Grid>
          </Grid>
          {/* <Grid
                container
                spacing={2}
                sx={{ p: 1 }}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  sx={{
                    cursor: "pointer",
                    background:
                      !props.isValid && !props.dirty
                        ? "#b3b3b3"
                        : "rgb(245, 132, 31)",
                    color:
                      !props.isValid && !props.dirty ? "#b3b3b3" : Colors.WHITE,
                    px: 6,
                    my: 5,
                    borderRadius: "5px",
                    "&:hover": { opacity: 0.9 },
                  }}
                  type="submit"
                  disabled={!(props.isValid && props.dirty)}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Next"
                  )}
                </Button>
              </Grid> */}
          {/* <TextField
          variant="outlined"
          size="medium"
          required={true}
          type={"text"}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  backgroundColor: "#E9ECF3",
                  p: 1,
                  borderRadius: "5px",
                }}
              >
                +91
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end">
                  <CheckCircleIcon
                  // color={meta.value && !meta.error ? "success" : "disabled"}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        /> */}
        </Box>
      </Box>
    );
  }
);

export default AadharAuthentication;

export const validationSchema = Yup.object({
  mobileNumber: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
    .required("Mobile number is required"),
});

export const validateValue = (validator, value) => {
  if (value !== "") {
    if (validator) {
      if (new RegExp(validator).test(value)) {
        return true;
      }
    }
  }
  return false;
};
